import { render, staticRenderFns } from "./LeadCustomer.vue?vue&type=template&id=c8fe0622&scoped=true"
import script from "./LeadCustomer.vue?vue&type=script&lang=ts"
export * from "./LeadCustomer.vue?vue&type=script&lang=ts"
import style0 from "./LeadCustomer.vue?vue&type=style&index=0&id=c8fe0622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fe0622",
  null
  
)

export default component.exports